import * as React from "react";
import {cx} from "emotion";

import "./select-target-section.scss";

import {cs}       from "@Common/react/chain-services";
import {UseState} from "@Common/react/use-state";
import {Static2}  from "@Common/react/static-2";

import {SelectTargetForms} from "./select-target-forms/select-target-forms";
import {Radio} from "../../../../../../../common/design2/radio/radio";

export const SelectTargetSection = ({next}) => cs(
    ["type", (_, next) => UseState({
        initValue: "zip",
        next,
    })],
    ["forms", ({}, next) => SelectTargetForms({next})],
    ["selectTargetForm", ({forms, type}, next) => next(type.value && forms.getForm(type.value))],
    ({selectTargetForm, type}) => next({
        valid: selectTargetForm?.valid,
        highlightErrors: selectTargetForm?.highlightErrors,
        getSearchRequest: () => ({
            mode: type.value,
            ...selectTargetForm?.getSearchRequest(),
        }),
        handleApiError: selectTargetForm?.handleApiError,
        clearApiError: selectTargetForm?.clearApiError,
        render: ({unplottedZips, showErrors}) => (
            <div className="select-target-section-22n">
                <div className="header">
                    <div className="title" xd-qa-type="label" xd-qa-name="New Homeowners Select an Area">
                        Select an Area
                    </div>
                    
                    <div className="sub-title" xd-qa-type="label" xd-qa-name="New Homeowners Select an Area Description">
                        To get started, select areas you want to target:
                    </div>
                </div>
                
                {TargetTypes({
                    selected: type.value,
                    onSelect: (type1) => type.change(() => type1),
                })}

                {selectTargetForm && (
                    <div className="box">
                        {selectTargetForm.render({
                            showErrors,
                        })}
                        {!!unplottedZips?.length && cs(
                            ["scrollPosition", (_, next) => UseState({initValue: 0, next})],
                            ["scrollRef", (_, next) => Static2({next})],
                            ["barRef", (_, next) => Static2({next})],
                            ["thumbRef", (_, next) => Static2({next})],
                            ({scrollPosition, scrollRef, barRef, thumbRef}) => (
                                <div className="unplotted-zips">
                                    <div
                                        className="box"
                                        ref={scrollRef.set}
                                        onScroll={() => scrollPosition.onChange(scrollRef.get().scrollTop)}
                                    >
                                        <div className="icon" xd-qa-name="New Homeowners Warning Icon" xd-qa-type="icon">
                                            <img src={require("./warning.svg")}/>
                                        </div>
                                        <div className="content">
                                            <div className="label" xd-qa-name="New Homeowners Unplotted Zips Label" xd-qa-type="label">
                                                {`The following zip code${unplottedZips.length > 1 ? 's' : ''} could not be plotted`}
                                            </div>
                                            {unplottedZips.map((zip, i) => (
                                                <div className="zip" key={zip.zipCode} xd-qa-name={`New Homeowners Unplotted Zip ${i}`} xd-qa-type="label">
                                                    {zip.zipCode}
                                                    <span 
                                                        className="count"
                                                        xd-qa-name={`New Homeowners Unplotted Zip ${i} Qty`}
                                                        xd-qa-type="label"
                                                    >
                                                        {`${zip.count} Results`}
                                                    </span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    {scrollRef.get() && unplottedZips.length > 5 && <div className="scrollbar" ref={barRef.set}>
                                        <div 
                                            className="thumb"
                                            ref={thumbRef.set}
                                            style={{
                                                top: `${(scrollPosition.value / scrollRef.get().scrollHeight) * 100}%`,
                                                height: `${(scrollRef.get().clientHeight / scrollRef.get().scrollHeight) * 100}%`,
                                            }}
                                            onMouseDown={(eDown) => {
                                                const thumbY = eDown.clientY;
                                                const startTop = (parseInt(thumbRef.get().style.top) * scrollRef.get().clientHeight) / 100;
                                                const mouseMove = ((eMove) => {
                                                    const delta = eMove.clientY - thumbY;
                                                    const newTop = Math.max(startTop + delta, 0);
                                                    let scrollTop;
                                                    if (newTop > barRef.get().clientHeight - thumbRef.get().clientHeight) {
                                                        scrollTop = scrollRef.get().scrollHeight - scrollRef.get().clientHeight;
                                                    } else {
                                                        scrollTop = (newTop / scrollRef.get().clientHeight) * scrollRef.get().scrollHeight;
                                                    }
                                                    scrollRef.get().scrollTop = scrollTop;
                                                    scrollPosition.onChange(scrollTop);
                                                });
                                                document.addEventListener("mousemove", mouseMove);

                                                const mouseUp = (() => {
                                                    document.removeEventListener("mousemove", mouseMove);
                                                    document.removeEventListener("mouseup", mouseUp);
                                                });
                                                document.addEventListener("mouseup", mouseUp);
                                            }}
                                        />
                                    </div>}
                                </div>
                            )
                        )}
                    </div>
                )}
            </div>
        ),
    }),
);

const TargetTypes = ({selected, onSelect}) => (
    <div className={cx("target-types")}>
        {[
            {
                searchType: "zip",
                label: "By Zip Code",
            },
            {
                searchType: "state",
                label: "By City",
            },
        ]
            .map(({searchType, label}) => (
                <div
                    className="target-type" key={searchType}
                    onClick={() => onSelect(searchType)}
                >
                    {Radio({
                        selected: searchType === selected,
                        xdQaName: "New Homeowners "+label,
                    })}
                    <div className="label" xd-qa-type="label" xd-qa-name={"New Homeowners "+label}>
                        {label}
                    </div>
                </div>
            ))
        }
    </div>
);